import { render, staticRenderFns } from "./RegionTree.vue?vue&type=template&id=72459559"
import script from "./RegionTree.vue?vue&type=script&lang=js"
export * from "./RegionTree.vue?vue&type=script&lang=js"
import style0 from "./RegionTree.vue?vue&type=style&index=0&id=72459559&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports